import { ColorService } from "../tools/ui/color.service";
import { HSLColor } from "../tools/ui/hsl-color";
import { Agency } from "./agency";
import { EStrategyStatus } from "./enum/strategy-status";
import { Portfolio } from "./portfolio";
import { StrategyDocument } from "./strategy-document";
import { EStrategyType } from "./strategy-type";
import { User } from "./user";
import { Work } from "./work";

export class Strategy {

    Id: number;
    Type: EStrategyType;
    Status: EStrategyStatus = EStrategyStatus.Ordered;
    CreatedBy: User;

    ModifiedOn: Date;
    ModifiedBy: User;

    IsFavorite: boolean;

    HasInitialMeasurement: boolean;
    HasEnvironmentalMeasurement: boolean;
    HasPostMaintenanceMeasurement: boolean;

    // !Trash field for unmodeled data
    Comment: string;
    //
    Work: Work = new Work();
    Portfolio: Portfolio = new Portfolio();

    StrategyDocumentList: StrategyDocument[] = [];

    ProcessList: string[] = [];

    Agency: Agency;
    SamplingAgency: Agency;

    WithPerimeter: boolean;
    /* Pour le juridique */
    PartnerName: string;
    Rcs: string;
    /**/
    IsFDX: boolean = true;
    ContexteHorsStrategie: boolean = false;
    CanDownloadSyntheseChantier: boolean = false;

    static mapFromJSON(json) {
        const s = new Strategy();

        s.Id = json['id'];
        s.Type = json['type'];
        s.IsFavorite = json['isFavorite'];
        s.Status = json['status'];
        s.HasEnvironmentalMeasurement = json['hasEnvironmentalMeasurement'];
        s.HasInitialMeasurement = json['hasInitialMeasurement'];
        s.HasPostMaintenanceMeasurement = json['hasPostMaintenanceMeasurement'];
        s.Comment = json['comment'];
        s.IsFDX = json['isFDX'];

        s.PartnerName = json['partnerName'];
        s.Rcs = json['rcs'];
        s.WithPerimeter = json['withPerimeter']
        s.ProcessList = json['processList']

        s.ContexteHorsStrategie = json['contexteHorsStrategie'];
        s.CanDownloadSyntheseChantier = json['canDownloadSyntheseChantier'];

        if (json['work']) {
            s.Work = Work.mapFromJSON(json['work']);
        }
        if (json['portfolio']) {
            s.Portfolio = Portfolio.mapFromJSON(json['portfolio']);
        }
        if (json['strategyDocuments']) {
            s.StrategyDocumentList = json['strategyDocuments'].map(x => StrategyDocument.mapFromJSON(x));
        }

        if (json['agency']) {
            s.Agency = Agency.mapFromJSON(json['agency']);
        }

        if (json['samplingAgency']) {
            s.SamplingAgency = Agency.mapFromJSON(json['samplingAgency']);
        }
        return s;
    }
}